import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import useAuthCon from "../composant_reutilisable/useAuthCon";
import LoadingSpinner from "../composant_reutilisable/loading";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { Modal, Button, Form } from 'react-bootstrap';

const Connexion = () => {
    useAuthCon();
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const [formData, setFormData] = useState({ email: "", mdp: "" });
    const [showPassword, setShowPassword] = useState(false);
    const [alert, setAlert] = useState({ message: "", type: "" });
    const [showModal, setShowModal] = useState(false);
    const [email, setEmail] = useState("");

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const showAlert = (message, type = "danger") => {
        setAlert({ message, type });
        setTimeout(() => {
            setAlert({ message: "", type: "" });
        }, 5000);
    };

    const handleCloseModal = () => {
        setShowModal(false);
        setEmail("");
    };

    // ✅ Fonction pour vérifier le localStorage après stockage
    const verifierLocalStorage = () => {
        console.log("=== VÉRIFICATION LOCALSTORAGE APRÈS STOCKAGE ===");
        console.log("access_token:", localStorage.getItem('access_token'));
        console.log("refresh_token:", localStorage.getItem('refresh_token'));
        console.log("userId:", localStorage.getItem('userId'));
        console.log("groupe_id:", localStorage.getItem('groupe_id'));
        console.log("user_nom:", localStorage.getItem('user_nom'));
        console.log("user_prenoms:", localStorage.getItem('user_prenoms'));
        console.log("user_email:", localStorage.getItem('user_email'));
        
        // Vérifier la longueur du token
        const token = localStorage.getItem('access_token');
        if (token) {
            console.log("Longueur du token:", token.length);
            console.log("Début du token:", token.substring(0, 50) + "...");
        } else {
            console.error("❌ ERREUR: access_token est null ou undefined !");
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);

        try {
            console.log("📡 Envoi requête de connexion...");
            
            const response = await fetch(`${process.env.REACT_APP_HOTE}/api/web/connexion/`, {
                method: "POST",
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    email: formData.email,
                    mdp: formData.mdp
                }),
            });

            const data = await response.json();
            console.log("=== RÉPONSE COMPLÈTE DU BACKEND ===", data);
            console.log("Status HTTP:", response.status);
            console.log("Success:", data.success);
            console.log("Message:", data.message);

            setIsLoading(false);

            if (response.ok && data.success) {
                console.log("✅ Connexion réussie, stockage des données...");
                
                // Vérifier que les tokens existent dans la réponse
                if (!data.data.access_token) {
                    console.error("❌ ERREUR: access_token manquant dans la réponse !");
                    console.log("data.data reçu:", data.data);
                    showAlert("Erreur: Token manquant dans la réponse", "danger");
                    return;
                }
                
                if (!data.data.refresh_token) {
                    console.error("❌ ERREUR: refresh_token manquant dans la réponse !");
                }
                
                // Stockage des tokens
                localStorage.setItem("access_token", data.data.access_token);
                localStorage.setItem("refresh_token", data.data.refresh_token);
                localStorage.setItem("userId", data.data.id);
                
                console.log("✅ Tokens stockés avec succès");
                
                // Stockage du groupe_id
                if (data.data.groupe_id) {
                    localStorage.setItem("groupe_id", data.data.groupe_id);
                    console.log("✅ groupe_id stocké:", data.data.groupe_id);
                } else if (data.data.groupes && data.data.groupes.length > 0) {
                    localStorage.setItem("groupe_id", data.data.groupes[0].id);
                    console.log("✅ groupe_id stocké depuis groupes:", data.data.groupes[0].id);
                } else {
                    console.warn("⚠️ Aucun groupe_id trouvé dans la réponse");
                }
                
                // Stockage des informations utilisateur
                localStorage.setItem("user_nom", data.data.nom || "");
                localStorage.setItem("user_prenoms", data.data.prenoms || "");
                localStorage.setItem("user_email", data.data.email || "");
                
                // Vérification finale
                verifierLocalStorage();
                
                showAlert("Connexion réussie ! Redirection...", "success");
                
                // Redirection vers Dashboard
                setTimeout(() => {
                    console.log("🚀 Redirection vers Dashboard...");
                    navigate("/Dashboard");
                }, 1000);
            } else {
                console.error("❌ Erreur d'authentification:", data.message);
                showAlert(data.message || "Erreur d'authentification.", "danger");
            }
        } catch (error) {
            setIsLoading(false);
            console.error("❌ Erreur réseau ou serveur:", error);
            showAlert("Erreur de connexion au serveur.", "danger");
        }
    };

    const handleInscription = () => {
        navigate("/Inscription");
    };

    const handleResetPassword = async (e) => {
        e.preventDefault();
        
        if (!email) {
            showAlert("Veuillez saisir votre email.", "danger");
            return;
        }
        
        setIsLoading(true);
        
        try {
            const response = await fetch(`${process.env.REACT_APP_HOTE}/mot-de-passe-oublie/`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ email }),
            });

            const data = await response.json();
            setIsLoading(false);
            
            if (response.ok) {
                setShowModal(false);
                showAlert("Un lien a été envoyé sur votre adresse email pour réinitialiser votre compte.", 'success');
                setEmail("");
            } else {
                showAlert(data.message || "Une erreur est survenue.", 'danger');
            }
        } catch (error) {
            setIsLoading(false);
            showAlert("Erreur de connexion au serveur.", 'danger');
        }
    };

    return (
        <>
            {isLoading ? (
                <LoadingSpinner />
            ) : (
                <div
                    className="loginColumns animated fadeInDown"
                    style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        minHeight: "100vh",
                    }}
                >
                    <div className="ibox" style={{ width: "100%", maxWidth: "400px" }}>
                        <div className="ibox-content">
                            <h2 className="text-center">
                                <strong>AWETCHE</strong>
                            </h2>

                            {alert.message && (
                                <div className={`alert alert-${alert.type}`}>{alert.message}</div>
                            )}

                            <form role="form" className="p-2" onSubmit={handleSubmit}>
                                <div className="form-group mb-0">
                                    <label className="col-form-label">Email</label>
                                    <input
                                        type="email"
                                        name="email"
                                        placeholder="Entrez votre email"
                                        className="form-control"
                                        value={formData.email}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>
                                
                                <div className="form-group">
                                    <label className="col-form-label">Mot de passe</label>
                                    <div className="position-relative">
                                        <input
                                            type={showPassword ? "text" : "password"}
                                            name="mdp"
                                            placeholder="Entrez votre mot de passe"
                                            className="form-control"
                                            value={formData.mdp}
                                            onChange={handleChange}
                                            required
                                        />
                                        <span
                                            onClick={() => setShowPassword(!showPassword)}
                                            style={{
                                                position: "absolute",
                                                top: "50%",
                                                right: "15px",
                                                transform: "translateY(-50%)",
                                                cursor: "pointer",
                                                color: "#666",
                                            }}
                                        >
                                            {showPassword ? <FaEyeSlash /> : <FaEye />}
                                        </span>
                                    </div>
                                    <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "4px" }}>
                                        <small>
                                            <span
                                                onClick={() => setShowModal(true)}
                                                style={{
                                                    cursor: "pointer",
                                                    color: "#3088C0",
                                                    textDecoration: "none",
                                                }}
                                                onMouseOver={(e) => e.target.style.textDecoration = "underline"}
                                                onMouseOut={(e) => e.target.style.textDecoration = "none"}
                                            >
                                                Mot de passe oublié ?
                                            </span>
                                        </small>
                                    </div>
                                </div>
                                
                                <div className="mt-3">
                                    <button
                                        className="btn btn-sm btn-success col-md-12 mb-2"
                                        type="submit"
                                    >
                                        <strong>Connexion</strong>
                                    </button>

                                    <button
                                        className="btn btn-outline btn-success col-md-12"
                                        type="button"
                                        onClick={handleInscription}
                                    >
                                        <strong>Inscription</strong>
                                    </button>
                                </div>
                            </form>
                        </div>
                        
                        <div className="row">
                            <div className="col-md-12 w-100 text-center">
                                <small><a href="" target="_blank" rel="noopener noreferrer" style={{ color: "#3088C0" }}>Show time</a> &copy; 2025. Tous droits réservés | Réalisé par <a href="https://inovact.com/" target="_blank" rel="noopener noreferrer" style={{ color: "#3088C0" }}>INOVACT SARL</a></small>
                            </div>
                        </div>

                        <Modal show={showModal} onHide={handleCloseModal} centered>
                            <Modal.Header closeButton>
                                <Modal.Title>Réinitialiser le mot de passe</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <Form>
                                    <Form.Group controlId="email">
                                        <Form.Label>Votre email</Form.Label>
                                        <Form.Control
                                            type="email"
                                            placeholder="Entrer votre email"
                                            value={email}
                                            onChange={(e) => setEmail(e.target.value)}
                                            required
                                        />
                                    </Form.Group>
                                </Form>
                            </Modal.Body>
                            <Modal.Footer>
                                <Button variant="secondary" onClick={handleCloseModal}>
                                    Fermer
                                </Button>
                                <Button variant="success" onClick={handleResetPassword}>
                                    Réinitialiser
                                </Button>
                            </Modal.Footer>
                        </Modal>
                    </div>
                </div>
            )}
        </>
    );
};

export default Connexion;